﻿export const getSatser = async (): Promise<SlettingAvRenterSatser> => {
    const response = await fetch('/api/mt1535/satser/slettingavrenter');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export interface SlettingAvRenterSatser {
    SATS_ST07_TilleggAarsinntektRFBarn: number;
    SATS_ST07_Inntektsgrense1Mnd: number;
}
